module.exports = __webpack_public_path__ + "static/media/spoonerism-task (17).2c79e2b9.mp3";